import { URL_UPLOAD_FILE } from 'constants/urls';
import getCustIdByHostname from 'libs/getCustIdByHostname';

/**
 * @typedef {Object} FileData
 * @property {number} ErrorType
 * @property {string} Message
 * @property {Object} Payload
 * @property {string} Payload.Id
 * @property {string} Payload.Name
 * @property {number} Payload.Size
 * @property {string} Payload.ContentType
 * @property {number} Payload.CustomerId
 * @property {string | null} RedirectLink
 * @property {boolean} Success
 */

/**
 * @function uploadFile
 * @async
 * @param {object} file
 * @returns {Promise<FileData>}
 */
const uploadFile = async (file) => {
	const custId = getCustIdByHostname();

	const formData = new FormData();

	formData.append('File', file);
	formData.append('CustomerId', Number(custId));
	formData.append('CaseId', 0);

	const options = {
		method: 'POST',
		body: formData,
	};

	const res = await fetch(URL_UPLOAD_FILE, options);

	if (!res.ok) {
		const message = `HTTP error! status: ${res.status}`;
		throw new Error(message);
	} else {
		/**@type {FileData} data */
		const data = await res.json();
		return data;
	}
};

export default uploadFile;
